var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLdsLogoJa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "135px",
    height: "56.777px",
    viewBox: "0 0 135 56.777",
    enableBackground: "new 0 0 135 56.777",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M17.707,19.508l-1.562-0.991C14.251,21.572,9.803,27.813,0,29.189v0.474 c4.287-0.418,7.608-1.459,10.369-3.091v11.482h1.611V25.513C14.152,23.926,15.979,21.917,17.707,19.508z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666666",
    points: "28.639,35.174 28.639,22.648 35.457,22.648 35.457,21.744 20.117,21.744 20.117,22.648  26.982,22.648 26.982,35.174 18.461,35.174 18.461,36.118 37.396,36.118 37.396,35.174  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M51.389,29.597c1.805-2.684,2.912-5.679,3.588-8.369h-12.78v0.86h10.577 c-0.482,3.807-3.943,12.101-13.607,14.72l0.144,0.431c5.387-0.826,9.03-3.524,11.501-6.827c2.375,0.944,5.931,4.308,7.387,6.913 l1.562-1.118C55.516,31.678,53.878,30.904,51.389,29.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M112.74,29.597c1.805-2.684,2.911-5.679,3.59-8.369h-12.783v0.86h10.578 c-0.482,3.807-3.943,12.101-13.606,14.72l0.142,0.431c5.388-0.826,9.03-3.524,11.502-6.827c2.375,0.944,5.932,4.308,7.388,6.913 l1.561-1.118C116.867,31.678,115.23,30.904,112.74,29.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M60.634,29.58c0.944,0,1.708-0.692,1.708-1.554c0-0.855-0.764-1.551-1.708-1.551 c-0.942,0-1.707,0.695-1.707,1.551C58.927,28.888,59.691,29.58,60.634,29.58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.995,
    y: 23.079,
    fill: "#666666",
    width: 16.76,
    height: 0.99
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.25,
    y: 30.709,
    fill: "#666666",
    width: 18.889,
    height: 0.987
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666666",
    points: "77.043,38.356 75.375,18.775 73.861,18.775 75.527,38.356  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.795,
    y: 19.077,
    fill: "#666666",
    width: 1.611,
    height: 12.308
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M97.738,19.119v7.963c0,4.173-0.662,10.112-7.953,11.103v0.431c7.953,0,9.657-6.456,9.609-11.533v-7.963 H97.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M124.916,25.473v-6.698h-1.656v19.796h1.656V26.474c3.006,0.316,5.545,1.478,9.09,4.781L135,29.922 C133.032,28.424,129.638,26.163,124.916,25.473z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M43.747,5.443h4.043V5.078h-4.484V2.604h5.228V2.237h-5.228V0.259L42.402,0v2.237h-5.102v0.367h5.102 v2.474h-4.005v0.365h3.365c-0.889,1.862-2.726,4.166-4.785,5.046l0.033,0.226c2.971-1.003,4.435-3.055,5.392-4.713v5.875h0.903 V5.443h0.141c1.49,3.433,3.149,4.263,4.573,5l0.885-1.065C46.634,8.836,44.879,7.591,43.747,5.443z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M60.963,0.742v0.372h-6.069V1.042L53.99,0.785v11.148h0.903v-1.244h6.069v1.244h0.902V1.001L60.963,0.742 z M60.963,1.48v3.769h-6.069V1.48H60.963z M54.894,10.324V5.615h6.069v4.709H54.894z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M76.488,0.968v0.4h-2.42V1.292L73.26,0.968v4.777h0.809V5.041h2.42v0.705h0.807V1.292L76.488,0.968z  M74.068,4.676V1.734h2.42v2.942H74.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M72.775,0.769h-6.197v0.368h1.129v4.02c-0.381,0.023-0.77,0.046-1.162,0.075l0.389,0.871 c0.807-0.156,1.617-0.341,4.002-0.988v1.31h0.871V1.136h0.969V0.769z M70.936,3.55h-2.42V2.454h2.42V3.55z M68.516,5.106V3.84 h2.42v1.022C70.381,4.975,69.512,5.044,68.516,5.106z M70.936,2.163h-2.42V1.136h2.42V2.163z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666666",
    points: "72.84,10.904 72.84,9.172 76.745,9.172 76.745,8.806 72.84,8.806 72.84,7.299 77.49,7.299  77.49,6.933 67.547,6.933 67.547,7.299 71.969,7.299 71.969,8.806 68.322,8.806 68.322,9.172 71.969,9.172 71.969,10.904  66.578,10.904 66.578,11.27 78.361,11.27 78.361,10.904  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M84.751,0.065c-1.002,2.002-1.97,2.969-2.613,3.325l0.097,0.192c2.389-1.258,2.678-1.969,3.613-3.162 L84.751,0.065z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M86.076,3.196l-1.035-0.388c-0.807,1.743-1.422,2.937-3.098,4.293l0.098,0.161 c0.769-0.463,1.328-0.867,1.773-1.245v5.86h0.84V5.197h-0.01C85.174,4.579,85.513,3.968,86.076,3.196z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M94.016,4.848V4.482h-3.938V2.474h2.937V2.109h-2.937V0.291l-0.902-0.258v2.077h-2.68v0.365h2.68v2.008 H86.01v0.366h3.165v5.245c-0.979-0.309-1.372-0.844-1.782-1.709c0.226-0.752,0.363-1.53,0.457-2.282l-1.001-0.259 c0,2.518-0.903,5.003-1.839,5.875l0.129,0.16c1.065-0.804,1.718-1.912,2.131-3.108c0.709,1.929,1.792,2.424,6.07,2.689 l0.513-1.002c-1.7,0.013-2.897-0.035-3.775-0.166V7.509h3.132V7.143h-3.132V4.848H94.016z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M51.963,48.873h2.285v-0.364H52.23c0.623-0.894,1.029-1.78,1.338-2.511l-0.871-0.486 c-0.348,1.182-0.762,2.152-1.302,2.997H50.31v-1.57h1.841v-0.367H50.31v-1.575h-0.841v1.575H47.76v0.367h1.709v1.57h-2.451v0.364 h4.129c-0.387,0.541-0.834,1.024-1.363,1.477h-2.088v0.364h1.632c-0.665,0.505-1.444,0.978-2.374,1.446l0.096,0.13 c1.235-0.425,2.231-0.966,3.045-1.576h1.742c-0.077,0.19-0.266,0.544-0.734,1.06h-0.679v3.961 c-0.024,0.017-0.071,0.017-0.16,0.011c-0.194-0.02-0.163,0.03-0.938-0.1l0.196,1.052c0.709-0.05,1.659-0.083,1.678-0.613v-4.067 c0.638-0.447,1.173-0.806,1.921-1.667h-2.561C51.115,49.878,51.576,49.378,51.963,48.873z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M47.42,53.388c2.018-0.063,5.616-0.452,6.472-0.712l0.08,0.146c-3.098,0.969-5.132,1.309-6.262,1.422 L47.42,53.388z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M59.057,48.067v-0.364H55.41c0.285-0.739,0.551-1.576,0.807-2.547l-1.064-0.227 c-0.032,1.584-0.422,3.262-1.84,5.972l0.161,0.066c0.46-0.497,0.862-1.06,1.228-1.722c0.186,1.567,0.451,2.988,0.998,4.258 c-0.695,1.071-1.752,2.057-3.42,3.047l0.129,0.227c1.663-0.677,2.809-1.582,3.613-2.597c0.49,0.91,1.162,1.746,2.1,2.5 l0.936-0.842c-1.14-0.607-1.991-1.209-2.653-2.194c1.173-1.774,1.462-3.819,1.725-5.577H59.057z M56.012,52.975 c-0.483-0.958-0.848-2.23-1.15-4.035c0.141-0.273,0.272-0.562,0.402-0.872h1.932C56.98,49.996,56.755,51.569,56.012,52.975z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M78.232,45.587c1.173,1.879,1.869,3.148,5.066,4.509l0.84-1.132c-3.196-0.742-4.423-1.805-5.746-3.646 l-1.032-0.452c-1.874,3.162-3.065,4.294-5.294,5.196l0.098,0.163C76.224,48.818,77.173,47.372,78.232,45.587z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.874,
    y: 49.378,
    fill: "#666666",
    width: 5.938,
    height: 0.37
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "M72.613,51.976h3.904c-0.605,1.498-1.207,2.447-1.705,3.124c-0.611,0.024-1.205,0.044-1.746,0.065 l0.355,0.999c1.201-0.094,3.581-0.284,7.617-1.291c0.266,0.48,0.488,1.023,0.662,1.631l1.195-0.42 c-1.083-1.92-2.179-2.663-3.181-3.148l-0.192,0.16c0.539,0.403,1.002,0.922,1.383,1.548c-1.044,0.193-3.424,0.337-5.66,0.434 c1.24-1.2,2.114-2.409,2.6-3.102h5.646v-0.367H72.613V51.976z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdsLogoJa);
export default __webpack_public_path__ + "static/media/lds-logo_ja.4e2085caac5a8379144aeb2277883cf2.svg";
export { ForwardRef as ReactComponent };